import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { createStatusField } from '../../../util/format';

interface ClaimRow {
    claimNumber: string;
    contractName: string;
    visitType: string;
    creationDate: string;
    chargeAmount: number;
    paidAmount: number;
    processingState: string;    
    error?: string;
}

interface ProcessedAuditClaimsProps {
    open: boolean;
    rows: ClaimRow[];
    onClose: () => void;
}

const ProcessedAuditClaims: React.FC<ProcessedAuditClaimsProps> = ({ open, rows, onClose }) => {
    function formatToLocalDate(utcDateString: string): string {
        const date = new Date(utcDateString);
        return date.toLocaleDateString(); 
    }
    return (
        <Dialog open={open} onClose={onClose} PaperProps={{
            style: {
                width: '75%',
                maxWidth: '75%',
            },
        }}>
            <DialogTitle>Processed Claims</DialogTitle>
            <DialogContent>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell>Claim Number</TableCell>
                        <TableCell>Contract</TableCell>
                        <TableCell>Visit</TableCell>
                        <TableCell>Creation Date</TableCell>
                        <TableCell>Charged Amount</TableCell>
                        <TableCell>Allowable</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Error Message</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableCell>{row.claimNumber}</TableCell>
                            <TableCell>{row.contractName}</TableCell>
                            <TableCell>{row.visitType}</TableCell>
                            <TableCell>{formatToLocalDate(row.creationDate)}</TableCell>                            
                            <TableCell>{row.chargeAmount}</TableCell>
                            <TableCell>{row.paidAmount}</TableCell>
                            <TableCell>
                                {createStatusField("processingState", "Status", { returnWholeRow: true })?.renderString(row)}
                            </TableCell>
                            <TableCell>
                                <div
                                    style={{
                                        maxHeight: 80,
                                        overflowY: 'auto',
                                        whiteSpace: 'pre-wrap',
                                        fontSize: '0.85rem',
                                        padding: '4px'
                                    }}
                                >
                                    {row.error || '—'}
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>Close</Button>
        </DialogActions>
        </Dialog>
    );
};

export default ProcessedAuditClaims;